export const UNIT_OPTIONS = ["EA","SF","SY","LF","LS","Allowance","%","Days","Weeks","Months"];

export const COL_DEFS = [
  {id:"status",      label:"Status",      width:"12%"},
  {id:"qty",         label:"Qty",         width:64},
  {id:"unit",        label:"Unit",        width:62},
  {id:"unitCost",    label:"Unit Cost",   width:112},
  {id:"total",       label:"Total",       width:98},
  {id:"proposal",    label:"Package",     width:142},
  {id:"altType",     label:"Alt Type",    width:100},
  {id:"contingency", label:"Contingency", width:148},
  {id:"notes",       label:"Notes",       width:160},
];

// notes starts off: it adds a second line to every row, and a new estimator
// has nothing to print there yet. Any note that exists is still shown --
// showRowLine decides that -- so turning the column off never hides writing.
export const DEFAULT_COLS = {status:true,qty:true,unit:true,unitCost:true,total:true,proposal:true,altType:true,contingency:true,notes:false,tradeName:false,tradeDate:false};

export const COL_PRESETS = [
  {id:"bidding",label:"Bidding",cols:{status:true,qty:false,unit:false,unitCost:false,total:true,proposal:true,altType:false,contingency:false,notes:true,tradeName:false,tradeDate:false}},
  {id:"review",label:"Review",cols:{status:false,qty:true,unit:true,unitCost:true,total:true,proposal:false,altType:false,contingency:false,notes:true,tradeName:false,tradeDate:false}},
  {id:"clean",label:"Clean",cols:{status:false,qty:false,unit:false,unitCost:false,total:true,proposal:false,altType:false,contingency:false,notes:false,tradeName:false,tradeDate:false}},
  {id:"all",label:"All",cols:{status:true,qty:true,unit:true,unitCost:true,total:true,proposal:true,altType:true,contingency:true,notes:true,tradeName:true,tradeDate:true}},
];
